import {
  Timestamp,
  isEnumValue,
  isObject,
  isTimestamp,
} from '@principle-theorem/shared';
import { isString } from 'lodash';
import { ISourceEntityTypes } from './source';

export enum SourceEntityRecordStatus {
  Valid = 'valid',
  Invalid = 'invalid',
}

export const SOURCE_ENTITY_RECORD_STATUS_MAP: {
  [key in SourceEntityRecordStatus]: string;
} = {
  [SourceEntityRecordStatus.Valid]: 'primary',
  [SourceEntityRecordStatus.Invalid]: 'warn',
};

export interface IMigrationDestination {
  key: string;
  value: SourceEntityRecordMigrationStatus;
}

export type FilterUnion<Obj extends FilterType> = {
  [K in keyof Obj]: ISourceEntityRecordFilter<Obj[K]>;
}[keyof Obj];

export interface ISourceEntityRecordFilter<Value = unknown> {
  key: string;
  value: Value;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FilterType = { [key: string]: any };

export interface ISourceEntityRecord<
  Source extends ISourceEntityTypes = ISourceEntityTypes,
> {
  uid: string;
  label: string;
  lastSync: Timestamp;
  status: SourceEntityRecordStatus;
  filters: FilterUnion<Source['filters']>[];
  migrationDestinations?: IMigrationDestination[];
  data: Source['data'];
  modifiedData?: Source['data'];
  translations: Source['translations'];
}

export enum SourceEntityRecordMigrationStatus {
  Migrated = 'migrated',
  NotMigrated = 'notMigrated',
  Failed = 'failed',
}

export function isSourceEntityRecord(
  item: unknown
): item is ISourceEntityRecord<ISourceEntityTypes> {
  return (
    isObject(item) &&
    isString(item.uid) &&
    isString(item.label) &&
    'data' in item &&
    'lastSync' in item &&
    isTimestamp(item.lastSync) &&
    'status' in item &&
    isEnumValue(SourceEntityRecordStatus, item.status)
  );
}
